module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-6-fe5a1eeb303dac1a6302ae5d721ce55f.svg";